import { ConfirmRouteSheetCard } from "./nextWorkCards/confirmRouteSheetCard";
import { SignedDocumentsCard } from "./nextWorkCards/signedDocumentsCard";
import { WaybillAndTimeSpentCard } from "./nextWorkCards/waybillsAndTimeSpentCard";
import { NextWorksId, Route } from "../../models/routes/route";
import { NextWorkCard } from "./nextWorkCards/nextWorkCard";
import { RouteStatus } from "../../models/enums/routeStatus";

interface NextWorkFlowCardProps {
    route: Route;
    onChangeRoute: (route: Route) => void;
    isReadyForFinishAction: boolean;
}

export const NextWorkFlowCard = ({ route, onChangeRoute, isReadyForFinishAction }: NextWorkFlowCardProps) => {
    const { nextWorksCheckListId } = route;

    if (!isReadyForFinishAction && nextWorksCheckListId !== NextWorksId.WaybillAndTimeSpentForBicycles) return null;

    switch (nextWorksCheckListId) {
        case NextWorksId.RouteSheetPhoto:
            return <ConfirmRouteSheetCard route={route} onChangeRoute={onChangeRoute} />;
        case NextWorksId.SignedDocumentsPhotoForBicycles:
            return <SignedDocumentsCard route={route} onChangeRoute={onChangeRoute} />;
        case NextWorksId.WaybillAndTimeSpentForBicycles:
            return <WaybillAndTimeSpentCard route={route} onChangeRoute={onChangeRoute} />;
        default:
            return (
                <NextWorkCard
                    route={route}
                    caption={route.status === RouteStatus.Finished ? "Выполнен" : "Введите время, чтобы завершить маршрут"}
                    onChangeRoute={onChangeRoute}
                />
            );
    }
};
